import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';

import { 
  makeStyles 
} from '@material-ui/core/styles';

import {
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@material-ui/core';

import {
  MoreVert as MoreIcon,
  ViewQuilt as CloudFormationStackIcon,
  Assessment as CloudWatchDashboardIcon,
  FileCopyOutlined as CopyIcon,
  OpenInNew as ExtLinkIcon,
} from '@material-ui/icons';

import {
  UserContext,
} from '../../user';

import { 
  fmtDashboardLink,
  fmtStackFilterLink,
  fmtTitleCase,
} from '../../utils/formatters';

import { 
  ResourcePolyIcon,
} from '.';

import {
  CopyToClipboard,
} from 'react-copy-to-clipboard';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  menuLabel: {
    padding: theme.spacing(1),
  }
}));

export default function ResourceAction(props) {
  const { resource, dashboard, stack, actions, size, view, copy } = props;
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [navToResource, setNavToResource] = React.useState(null);

  const handleActionMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleActionMenuClose = () => {
    setAnchorEl(null);
  };

  const handleActionClick = (action) => {
    handleActionMenuClose();
    if(action.onClick) {
      action.onClick(action.value);
    }
  };

  const handleGoToDashboard = (name) => {
    window.open(fmtDashboardLink(name),"_blank");
  };
  
  const handleGoToStack = (name) => {
    window.open(fmtStackFilterLink(name),"_blank");
  };

  const handleGoToResource = (resource) => {
    setNavToResource(resource);
  };

  const userContext=React.useContext(UserContext); 

  if (!resource) return(null);

  if(navToResource) {
    return <Redirect push to={"/resources/"+navToResource.ResourceType+"s/"+navToResource.ResourceId} />;  
  }

  const resourceTypeName=fmtTitleCase(resource.ResourceType);
  const standardActions=[];
  const resourceActions=Array.isArray(actions)?actions:actions(resource);
  
  if ( view ) {
    standardActions.push({ name: `View ${resourceTypeName}`, icon: ResourcePolyIcon, iconProps: { type: resource.ResourceType }, value: resource, onClick: handleGoToResource });
  }
  if ( copy ) {
    standardActions.push({ name: `Copy ${resourceTypeName} Id`, copy: true, value: resource.ResourceId });
  }
  const isAdmin = userContext.role==='Admin';
  if ( isAdmin && dashboard && resource.Dashboard==='ENABLED' ) {
    standardActions.push({ name: 'Go to Dashboard', icon: CloudWatchDashboardIcon, value: resource.StackName, onClick: handleGoToDashboard, external: true });
  }
  if ( isAdmin && stack ) {
    standardActions.push({ name: 'Go to Stack', icon: CloudFormationStackIcon, value: resource.StackName, onClick: handleGoToStack, external: true });
  }
  const divider=(standardActions.length&&resourceActions.length)?[{divider: true}]:[];
  const effectiveActions=[...resourceActions, ...divider, ...standardActions];

  return (
    <React.Fragment>
      <IconButton aria-label="resource-action-menu" onClick={handleActionMenuOpen} size={size}>
        <MoreIcon />
      </IconButton>
      { (effectiveActions.length && anchorEl)?
        <Menu
          id="action-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleActionMenuClose}
        >
          { effectiveActions.map( (action, index) => { 
            if(action.name) {
              const ActionIcon=action.icon;
              return(
                <MenuItem key={index} onClick={() => handleActionClick(action)} style={{ justifyContent: 'space-between'}}>
                  {action.copy?
                    <CopyToClipboard text={action.value}>
                      <div style={{ display: 'flex', alignItems: 'center'}} >
                        <CopyIcon fontSize='small'/>
                        <Typography className={classes.menuLabel} variant="body2">{action.name}</Typography>
                      </div>
                    </CopyToClipboard>
                    :
                    <div style={{ display: 'flex', alignItems: 'center'}}>
                      {ActionIcon?<ActionIcon fontSize="small" {...action.iconProps}/>:null}
                      <Typography className={classes.menuLabel} variant="body2">{action.name}</Typography>
                    </div>
                  }
                  {action.external?<ExtLinkIcon color="disabled" style={{fontSize: 'medium'}}/>:null}
                    
                </MenuItem>);
            } else if(action.divider) {
              return(<Divider key={index}/>);
            }
          })}
        </Menu>:null
      }
    </React.Fragment>  
  );
}

ResourceAction.propTypes = {
  resource: PropTypes.object.isRequired,
  view: PropTypes.bool.isRequired,
  copy: PropTypes.bool.isRequired,
  stack: PropTypes.bool.isRequired,
  dashboard: PropTypes.bool.isRequired,
  actions: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.func,
  ]).isRequired,
  size: PropTypes.oneOf(['small','medium']),
};

ResourceAction.defaultProps = {
  view: true,
  copy: true,
  stack: true,
  dashboard: true,
  actions: [],
  size: "medium"
};
